import humps from 'humps';
import _get from 'lodash/get';
import { toastr } from 'react-redux-toastr';
import * as fetchUtils from '../../../utils/FetchUtils';
import { createLoadingSelector } from '../../loading';

const createActionName = (name: string) => `app/ptc/transaction/lossModel/${name}`;
const ptcBaseUrl = (id: string, type: string) => `${process.env.REACT_APP_MP_API_HOST}/${type}/${id}`;
const initialState = {
    loading: false,
    errorMessage: '',
};
const processValue = {
    securitizationTransactionInvestmentNote: {
        status: 'processing',
    },
};

export const lossModelLoading = createLoadingSelector([createActionName('LOSS_MODEL_GET')]);
export const lossModelGenerating = createLoadingSelector([createActionName('LOSS_MODEL_GENERATE')]);
export const waterfallCriteriaLoading = createLoadingSelector([createActionName('WATERFALL_CRITERIA')]);

export const LOSS_MODEL_GET_REQUEST = createActionName('LOSS_MODEL_GET_REQUEST');
export const LOSS_MODEL_GET_SUCCESS = createActionName('LOSS_MODEL_GET_SUCCESS');
export const LOSS_MODEL_GET_FAILURE = createActionName('LOSS_MODEL_GET_FAILURE');

export const LOSS_MODEL_GENERATE_REQUEST = createActionName('LOSS_MODEL_GENERATE_REQUEST');
export const LOSS_MODEL_GENERATE_SUCCESS = createActionName('LOSS_MODEL_GENERATE_SUCCESS');
export const LOSS_MODEL_GENERATE_FAILURE = createActionName('LOSS_MODEL_GENERATE_FAILURE');

export const WATERFALL_CRITERIA_REQUEST = createActionName('WATERFALL_CRITERIA_REQUEST');
export const WATERFALL_CRITERIA_SUCCESS = createActionName('WATERFALL_CRITERIA_SUCCESS');
export const WATERFALL_CRITERIA_FAILURE = createActionName('WATERFALL_CRITERIA_FAILURE');

export default function lossModel(state = initialState, action: any) {
    switch (action.type) {
        case LOSS_MODEL_GET_SUCCESS || LOSS_MODEL_GENERATE_SUCCESS:
            return {
                ...state,
                ...action.payload,
            };
        case WATERFALL_CRITERIA_SUCCESS:
            return {
                ...state,
                waterFallCriteria: action.payload,
            };
        case LOSS_MODEL_GET_FAILURE || LOSS_MODEL_GENERATE_FAILURE || WATERFALL_CRITERIA_FAILURE:
            return {
                ...state,
                errorMessage: action.message,
            };
        default:
            return state;
    }
}

const mapLossModel = (lossModelData: any) => ({
    ...lossModelData,
    data: {
        ...lossModelData.data,
        ratingCeWithStress: _get(lossModelData, 'data.ratingCeWithStress', []).map((item: any) => ({
            ...item,
            cePercentElPlusUl: Number((item.cePercentElPlusUl * 100).toFixed(2)),
        })),
        betaGhhi: _get(lossModelData, 'data.betaGhhi', []).map((item: any) => ({
            ...item,
            betaEntity: Number(item.betaEntity).toFixed(2),
            betaPool: Number(item.betaPool).toFixed(2),
            ghhiEntityR: Number(item.ghhiEntityR).toFixed(2),
            ghhiPoolR: Number(item.ghhiPoolR).toFixed(2),
        })),
        ceBuildUpA1: _get(lossModelData, 'data.ceBuildUpA1', [])
            .slice(0, -1)
            .map((item: any) => ({
                ...item,
                cashCollatPer: Number(item.cashCollatPer.slice(0, -2)),
                eisPer: Number(item.eisPer.slice(0, -2)),
                overCollatPer: Number(item.overCollatPer.slice(0, -2)),
                payOutDate: item.payOutDate,
                total: Number(item.total.slice(0, -2)),
            })),
        ceBuildUpA2: _get(lossModelData, 'data.ceBuildUpA2', [])
            .slice(0, -1)
            .map((item: any) => ({
                ...item,
                cashCollatPer: Number(item.cashCollatPer.slice(0, -2)),
                eisPer: Number(item.eisPer.slice(0, -2)),
                overCollatPer: Number(item.overCollatPer.slice(0, -2)),
                payOutDate: item.payOutDate,
                total: Number(item.total.slice(0, -2)),
            })),
    },
});

export function getLossModel(id: any, type: string) {
    return (dispatch: any) => {
        dispatch({ type: LOSS_MODEL_GET_REQUEST, id });
        return fetchUtils
            .getJSON(`${ptcBaseUrl(id, type)}/investment_notes`)
            .then((d: any) => humps.camelizeKeys(d))
            .then((d: any) => {
                const payload = mapLossModel(d);
                return dispatch({
                    type: LOSS_MODEL_GET_SUCCESS,
                    payload,
                    id,
                });
            })
            .catch((err: any) => {
                fetchUtils.handleErrorV2(dispatch, err).then((m: any) => {
                    toastr.error('Error Initiating Loss Modelling', m);
                });
                return dispatch({ type: LOSS_MODEL_GET_FAILURE, errorMessage: err.message, id });
            });
    };
}

export function getTransactionSummary(id: any, type: string) {
    return (dispatch: any) => {
        dispatch({ type: WATERFALL_CRITERIA_REQUEST, id });
        return fetchUtils
            .getJSON(`${ptcBaseUrl(id, type)}/transaction_summary`)
            .then((d: any) => humps.camelizeKeys(d))
            .then((d: any) => {
                return dispatch({
                    type: WATERFALL_CRITERIA_SUCCESS,
                    payload: _get(d, 'transactionSummary', {}),
                    id,
                });
            })
            .catch((err: any) => {
                fetchUtils.handleErrorV2(dispatch, err).then((m: any) => {
                    toastr.error('Error fetching waterfall criteria', m);
                });
                return dispatch({ type: WATERFALL_CRITERIA_FAILURE, errorMessage: err.message, id });
            });
    };
}

export function generateLossModel(id: string, type: string) {
    return (dispatch: any) => {
        dispatch({ type: LOSS_MODEL_GENERATE_REQUEST, id });
        return fetchUtils
            .postJSON(`${ptcBaseUrl(id, type)}/investment_notes`, humps.decamelizeKeys(processValue))
            .then((d: any) => humps.camelizeKeys(d))
            .then((d: any) => {
                return dispatch({
                    type: LOSS_MODEL_GENERATE_SUCCESS,
                    payload: d,
                    id,
                });
            })
            .catch((err: any) => {
                fetchUtils.handleErrorV2(dispatch, err).then((m: any) => {
                    toastr.error('Error Initiating Loss Modelling', m);
                });
                return dispatch({ type: LOSS_MODEL_GENERATE_FAILURE, errorMessage: err.message, id });
            });
    };
}
